import React from "react";
import { ShimmerThumbnail } from "react-shimmer-effects";
import styles from "../styles/Dashboard.module.scss";

export default function ChartSkeleton({ height = 280 }) {
  return (
    <div className={styles.skeletonBlock} style={{ minHeight: height }}>
      <ShimmerThumbnail height={height} rounded />
    </div>
  );
}
